var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.625 32 0 60.625 0 96V416C0 451.375 28.625 480 64 480H384C419.375 480 448 451.375 448 416V96C448 60.625 419.375 32 384 32ZM128 384C110.375 384 96 369.625 96 352S110.375 320 128 320S160 334.375 160 352S145.625 384 128 384ZM128 192C110.375 192 96 177.625 96 160S110.375 128 128 128S160 142.375 160 160S145.625 192 128 192ZM320 384C302.375 384 288 369.625 288 352S302.375 320 320 320S352 334.375 352 352S337.625 384 320 384ZM320 192C302.375 192 288 177.625 288 160S302.375 128 320 128S352 142.375 352 160S337.625 192 320 192Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceFour);
export default __webpack_public_path__ + "static/media/dice-four.974a26e397d96a2b3abbbde3bbbafe88.svg";
export { ForwardRef as ReactComponent };